<template>
    <div
    class="modal right fade trader-info c-offer-modal"
    id="trader-info"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"       
    >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">HOLDINGS</h5>
            <button type="button" class="close"  @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <table class="table align-items-center table-flush table-hover bidtbl bid-acc">
            <thead class="thead-light psticky">
                <tr>
                    <th scope="col" class="text-left">CUSTOMER <br>ACCOUNT | TYPE</th>
                    <th scope="col">BOUGHT</th>
                    <th scope="col">COST</th>

                    <!-- <th scope="col">COUPON</th> -->
                    <th scope="col">QTY</th>
                    <th scope="col">AVLB QTY</th>
                    <th 
                        scope="col" 
                        class="sort text-center"
                        >SELL QTY</th> 
                    <th 
                    scope="col" 
                    class="sort text-center"
                    >SPREAD</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(holding) in holding" :key="holding.id"  >
                    <td class="text-left">
                        <span class="text-primary">{{holding.customerFirstName ? holding.customerFirstName[0] : ""}} {{holding.customerLastName}}</span><br>
                        <span>{{holding.accountVal}}</span> | 
                        <span class="text-success">{{holding.accountType}}</span> 
                    </td>
                    <td class="text-center">
                        <span>{{holding.boughtDate ? moment(holding.boughtDate).format("MM/DD/YYYY") : 'N/A'}}</span>
                    </td>
                    <td class="text-center"><span>{{holding.cost | currency}}</span></td>

                    <td class="text-center">
                        <span>{{holding.quantity}}</span><br>
                    </td> 
                    <td class="text-center">
                        <span>{{holding.availableQuantity}}</span><br>
                    </td> 
                    <td class="text-center">
                        <span>{{holding.sellQuantity}}</span><br>
                    </td> 
                    <td class="text-center">
                        <span>{{holding.spread}}</span>
                    </td> 
                   
                </tr>    
                
            </tbody>
            </table> 
            <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
            <div class="modal-footer bid">
                <button type="button" class="btn btn-secondary"  @click="$emit('close')">CLOSE</button>
            </div>
        </div>
        </div>
    </div>
    </div>
</template>

<script>
export default {
    name: 'createbidwanted',
    props: ['holding'],
    components :{
        
    },
    data() {
        return {
            loading : false,
            cusipName : this.holding ? this.holding[0].cusipVal : ""
        }

    },
    methods:{
    },
    mounted(){
        
    }
};
</script>
<style scoped>
.table i {
 color: #E96875 !important; 
}
</style>